import React from 'react';
import { ArrowRightIcon, BathIcon, ChefHatIcon, GemIcon, GridIcon, HammerIcon, HomeIcon, LayersIcon, LayoutPanelLeftIcon, WrenchIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  'granite-countertops': GemIcon,
  'kitchen-remodeling': ChefHatIcon,
  'bathroom-design': BathIcon,
  roofing: HomeIcon,
  'drywall-interior': LayersIcon,
  'wood-rot-repair': HammerIcon,
  'tile-flooring': GridIcon,
  'custom-cabinetry': LayoutPanelLeftIcon,
  handyman: WrenchIcon
};
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-white py-16 lg:py-20" data-id="element-327" data-mp="q2dfqjkufziq">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-328" data-mp="l4272c6abv23">
        <SectionHeading title={t.services.title} subtitle={t.services.subtitle} data-id="element-329" data-mp="g5qw1y497eia" />

        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-id="element-330" data-mp="36cpx40giwpav">
          {t.services.items.map((service, index) => {
          const Icon = icons[service.id] ?? GemIcon;
          return <Reveal as="li" key={service.id} delay={Math.min(index, 5) * 0.04} className="h-full" data-id="element-331" data-mp="2xcks1wysy2zv" data-mpi={index}>
                <article className="group flex h-full flex-col border-l-4 border-l-transparent border-y border-r border-black/10 bg-white p-7 shadow-card transition-[transform,box-shadow,border-color] duration-200 ease-smooth hover:-translate-y-1 hover:border-l-brand-500 hover:shadow-lift lg:p-8" data-id="element-332" data-mp="32bxmp3vx0ed0">
                  <Icon className="h-9 w-9 text-brand-500" aria-hidden="true" data-id="element-333" data-mp="3g17t84duy886" />
                  <h3 className="mt-5 font-display text-xl font-extrabold text-ink lg:text-2xl" data-id="element-334" data-mp="3l0ugz7rbb6v8">
                    {service.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#5B5B5B]" data-id="element-335" data-mp="24lszd9gy3wha">
                    {service.description}
                  </p>
                  <a href="#contact" className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold text-brand-600 underline decoration-brand-500/40 decoration-2 underline-offset-4 transition-colors duration-200 ease-smooth hover:text-ink hover:decoration-brand-500" data-id="element-336" data-mp="1pkm3ttvkplsl">
                    {t.services.learnMore}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-337" data-mp="16tl77chxe2c7" />
                  </a>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}